import { createFileRoute, notFound } from '@tanstack/react-router';
import { isUuid } from '@leanin/shared';
import type { PageMetaLoaderData } from '@/lib/analytics/page-meta';
import { learningTracksKeys } from '@/lib/queries/learning-tracks';
import { loadForRoute } from '@/lib/queries/load-for-route';
import { editorialTitleSubject } from '@/lib/seo-text';
import { useMember, mayCreateResource } from '@/lib/use-session';
import {
  LearningTrackDetailSkeleton,
  LearningTrackDetailView,
} from '@/components/learning-tracks/LearningTrackDetailView';

export const Route = createFileRoute(
  '/_public/resources/learning-tracks/$trackId/',
)({
  beforeLoad: ({ params }) => {
    if (!isUuid(params.trackId)) throw notFound();
  },
  loader: async ({ params, context: { queryClient } }): Promise<PageMetaLoaderData> => {
    const track = await loadForRoute(queryClient, learningTracksKeys.detail(params.trackId));
    return track === undefined ? {} : { pageId: track.id, pageTitle: editorialTitleSubject(track) };
  },
  pendingComponent: LearningTrackDetailSkeleton,
  component: LearningTrackDetailPage,
});

function LearningTrackDetailPage() {
  const { trackId } = Route.useParams();
  const me = useMember();
  const canManage = me !== null && mayCreateResource(me.platformRole);
  return (
    <LearningTrackDetailView trackId={trackId} canManage={canManage} />
  );
}
